import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useBox } from 'shared/hooks/utils';
import { memo, useCallback, useContext } from 'react';
import { Z3KSettings, Z3KSettingsEditor } from '../../provider/types';
import { SettingCard } from '../material-utils/settings-card/card';
import { TempStepField } from './temp-step-field';
import { MaterialBoolControl } from 'console/shared/components/fields';
import { usePartialAppSelector } from 'shared/hooks/redux/hooks';
import { selectDevice } from 'entities/device/lib';
export const InterfaceSettingsComponent = memo(function InterfaceSettingsComponent() {
    const { replace_config, config, deviceSettings } = useContext(Z3KSettingsEditor);
    const configBox = useBox(config);
    const changeShowControlDevicesState = useCallback((checked) => {
        replace_config({
            ...configBox.current,
            server_settings: {
                ...configBox.current.server_settings,
                show_control_devices_state: checked,
            },
        });
    }, [replace_config]);
    const { device_id, save_device_settings } = useContext(Z3KSettings);
    const hide_titles = usePartialAppSelector(selectDevice, device_id)?.hide_titles_on_heat_tab ??
        false;
    const onSetHideTitles = useCallback((value) => {
        save_device_settings({ hide_titles_on_heat_tab: value });
    }, [save_device_settings]);
    return (_jsxs(SettingCard, { title: "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 \u0438\u043D\u0442\u0435\u0440\u0444\u0435\u0439\u0441\u0430", children: [_jsx(TempStepField, {}), _jsx(MaterialBoolControl, { label: "\u0421\u043A\u0440\u044B\u0432\u0430\u0442\u044C \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u044F \u0433\u0440\u0443\u043F\u043F", help_id: "hide_titles_on_heat_tab", value: deviceSettings?.hide_titles_on_heat_tab ?? hide_titles, onChange: onSetHideTitles })] }));
});
